export const mediaUrl = media => typeof media === 'string' ? media : media?.url || '';
export const mediaKey = media => typeof media === 'string' ? media : media?.public_id ? `${media.resource_type || 'image'}:${media.public_id}` : media?.url;
export const isVideo = media => typeof media === 'object' && media?.resource_type === 'video';
export function mergeMedia(remote, fallback) {
  const unique = new Map();
  for (const media of [...remote, ...fallback]) if (!unique.has(mediaKey(media))) unique.set(mediaKey(media), media);
  return [...unique.values()];
}
